<div class="footer" id="mainfooter">
  <p class="alignleft">{{ CopyRightText }}</p>
  <p class="alignright">
    <a class="textcss" (click)="ReleaseNote()">Release Notes</a>
    <a class="textcss" (click)="DownloadUserManual()">User Guide</a>
    <a
      class="textcss"
      href="{{ TermsPrivacy }}"
      (click)="GetApplicationSettings()"
      target="_blank">
      Terms & Privacy
    </a>
    <a
      class="textcss"
      (click)="GetApplicationSettings()"
      (click)="op.toggle($event)">
      Help
    </a>
  </p>
</div>
<div class="HelpPopup">
  <p-overlayPanel
    #op
    [style]="{ 'background-color': '#F4F4F4', width: '50vh' }">
    <ng-template pTemplate>
      <div class="row">
        <div class="col-md-1">
          <img
            src="../../../../../assets/Images/icons8-phone-16.png"
            class="" />
        </div>
        <div class="col-md-9">
          <p class="helpleft">{{ contact }}</p>
        </div>
        <div class="col-md-2">
          <i
            class="pi pi-copy helpright"
            (click)="CopyData(contact)"
            pTooltip="{{ CopyMesg }}"
            tooltipPosition="top"></i>
          <span id="ContactTooltip">Copied</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-1">
          <img src="../../../../assets/Images/icons8-mail-16.png" class="" />
        </div>
        <div class="col-md-9">
          <p class="helpleft">{{ email }}</p>
        </div>
        <div class="col-md-2">
          <i
            class="pi pi-copy helpright"
            (click)="CopyData(email)"
            pTooltip="{{ CopyMesg }}"
            tooltipPosition="top"></i>
          <span id="EmailTooltip">Copied</span>
        </div>
      </div>
    </ng-template>
  </p-overlayPanel>
</div>
<div class="ConfirmationPopUp">
  <p-dialog
    [resizable]="true"
    header="Error"
    id="SessionTimeOut"
    [closable]="false"
    [(visible)]="SessionTimeOut"
    [modal]="true">
    <div>
      <label>{{ SessionAndUnauthorizedMessage }}</label>
    </div>
    <ng-template pTemplate="footer">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-5">
            <span></span>
          </div>
          <div class="col-md-12 batchrater-ok-button">
            <button
              pButton
              pRipple
              type="button"
              (click)="OnSessionTimeOut()"
              label="Ok"
              class="UserButton"
              SessionTimeOut="false"></button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
